var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTick({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/24px/Tick",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Mask",
    fill: "#1867F0",
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.51471863,20.4852814 L20.4852814,3.51471863 C25.1715729,8.20101013 25.1715729,15.7989899 20.4852814,20.4852814 C15.7989899,25.1715729 8.20101013,25.1715729 3.51471863,20.4852814 Z",
    id: "Oval",
    fill: "#2875FA"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-48",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "17.5652095 5.93933983 19.6865299 8.06066017 9.6258697 18.1213203 3.93933983 12.4347905 6.06066017 10.3134701 9.626 13.879"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.8e8bc637ca7059fb69fa2c7ad025fff0.svg";
export { ForwardRef as ReactComponent };